import { DataTable } from '@app/components/data-table/data-table';
import { DataTableToolbar } from '@app/components/data-table/data-table-toolbar';
import { useServerDataTable } from '@app/components/data-table/hooks/use-server-data-table';
import { DataTableProps } from '@app/components/data-table/types/data-table';
import { PaginatedGroupOrganizationListList } from '@shared/api/types';
import { useGroupOrganizationsColumns } from './group-organizations-table-columns';

interface GroupOrganizationsTableProps
  extends DataTableProps<PaginatedGroupOrganizationListList> {
  pageCount: number;
  periods: string[];
}

export default function GroupOrganizationsTable({
  data,
  status,
  isLoading,
  isFetchedAfterMount,
  isPreviousData,
  pageCount,
  periods,
}: GroupOrganizationsTableProps) {
  const { table, context } = useServerDataTable({
    data: data?.results ?? [],
    columns: useGroupOrganizationsColumns({ periods }),
    pageCount,
    getRowId: (row) => row.uuid,
    initialState: {
      columnVisibility: { uuid: false },
    },
  });

  return (
    <DataTable
      table={table}
      context={context}
      className="bg-gray-00"
      isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
      tableLoading={!data && status === 'loading'}
    >
      <DataTableToolbar table={table} />
    </DataTable>
  );
}
